import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { StyledSection } from '../Post/style.css';
import theme from '../../styles/theme';

const queryPostIntro = graphql`
	query specificPost4($postid: Int = 1479) {
		wordpressPost(wordpress_id: { eq: $postid }) {
			content
		}
	}
`;

const PostBajada = () => {
	return (
		<StaticQuery
			query={queryPostIntro}
			render={(data) => {
				const { content } = data.wordpressPost;
				return (
					<StyledSection bgColor="black" color={theme.clearcolor}>
						<div className="wrap wrapbajada">
							<div className="content" dangerouslySetInnerHTML={{ __html: content }} />
						</div>
					</StyledSection>
				);
			}}
		/>
	);
};

export default PostBajada;
